<mat-form-field [class.mini-form]="isMiniForm" [floatLabel]="'auto'" cropFieldLabel>
  <mat-label>
    <span class="tw-flex tw-items-center">
      <span cropText>
        {{ label | translate }}
        {{ isFieldRequired(ngControl['form']) }}
      </span>

      <ng-container *ngIf="tooltipText">
        <ui-svg-icon
          [name]="iconNames.QuestionFrame"
          [matTooltip]="tooltipText | translate"
          class="help-icon__with-height tw-align-middle"
        ></ui-svg-icon>
      </ng-container>
    </span>
  </mat-label>

  <mat-select
    [formControl]="countryCodeControl"
    class="country-code"
    disableOptionCentering
    [panelClass]="'country-code-select'"
    [attr.test-id]="testId"
    (selectionChange)="onSelected()"
  >
    <mat-select-trigger>
      <span class="flag" [ngClass]="countryCodeControl.value?.countryDialCode"></span>
      +{{ countryCodeControl.value?.dialCodeValue }}

      <ng-container *ngIf="!isMiniForm">
        (
        {{ countryCodeControl.value?.dialCodeName }}
        )
      </ng-container>
    </mat-select-trigger>

    <mat-option>
      <ngx-mat-select-search
        [formControl]="searchCountryCodeControl"
        [placeholderLabel]="'common.filter.search.label' | translate"
        [noEntriesFoundLabel]="'common.message.noCountriesFound' | translate"
      >
        <ui-svg-icon ngxMatSelectSearchClear [name]="iconNames.Close" class="tw-text-red-500"></ui-svg-icon>
      </ngx-mat-select-search>
    </mat-option>

    <mat-option
      *ngFor="let optionItem of filteredCountryDialCodes"
      [value]="optionItem"
      [attr.test-id]="optionItem.countryDialCode"
    >
      <span class="flag" [ngClass]="optionItem?.countryDialCode"></span>
      {{ optionItem.name }}
    </mat-option>
  </mat-select>

  <ng-container *ngIf="countryCodeControl.value && showClearButton" matSuffix>
    <ui-svg-icon
      *ngIf="countryCodeControl.value"
      [name]="iconNames.Close"
      (click)="onClearButtonClick($event)"
    ></ui-svg-icon>
  </ng-container>
</mat-form-field>
